import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";

const AdminSubNav = () => {
  const { modules } = useSelector((state) => state.auth);
  const location = useLocation();
  const [showNav, setShowNav] = useState(false);
  const [masterSettingsChildren, setMasterSettingsChildren] = useState([]);

  useEffect(() => {
    if (!modules || modules.length === 0) return;

    // Find Master Settings module
    const masterSettingsModule = modules.find(m => 
      m.name === 'Master Settings'
    );

    if (!masterSettingsModule) {
      setShowNav(false);
      return;
    }

    // Get all child modules of Master Settings
    const children = modules
      .filter(m => m.parent_id === masterSettingsModule._id)
      .sort((a, b) => (a.order || 999) - (b.order || 999));

    setMasterSettingsChildren(children);

    // Check if current path is a Master Settings child route
    const isChildRoute = children.some(child => 
      location.pathname === child.route_path || 
      (child.route_path && location.pathname.startsWith(child.route_path + '/'))
    );

    // Show subnav only if we're on a child route (not on master settings itself)
    const shouldShow = Boolean(isChildRoute);
    setShowNav(shouldShow);
  }, [location.pathname, modules]);

  // Don't show if no children or not on a child route
  if (!showNav || masterSettingsChildren.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        borderBottom: 1,
        borderColor: "divider",
        px: { xs: 1.5, sm: 3 },
        py: { xs: 1.2, sm: 2 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
          flexWrap: "wrap",
          overflowX: "auto",
        }}
      >
        {masterSettingsChildren.map((module) => (
          <NavLink
            key={module._id}
            to={module.route_path}
            style={({ isActive }) => ({
              color: isActive ? "#3b82f6" : "#6b7280",
              backgroundColor: isActive ? "#eff6ff" : "transparent",
              fontWeight: isActive ? 600 : 400,
              textDecoration: "none",
              padding: "8px 16px",
              borderRadius: "6px",
              border: isActive ? "1px solid #3b82f6" : "1px solid #e5e7eb",
              fontSize: "0.875rem",
              transition: "all 0.2s ease",
              '&:hover': {
                backgroundColor: isActive ? "#eff6ff" : "#f9fafb",
                borderColor: isActive ? "#3b82f6" : "#d1d5db",
              }
            })}
          >
            {module.name}
          </NavLink>
        ))}
      </Box>
    </Box>
  );
};

export default AdminSubNav;